import React from 'react';

import { Web3AuthCallback } from '@pkg/components';

import { type AuthProviders } from '@app/client/resources/w3auth/types';

interface W3aCallbackProps {
    provider: AuthProviders;
}

export function W3aCallback({ provider }: W3aCallbackProps) {
    return <Web3AuthCallback provider={provider} />;
}
